module.exports = __webpack_public_path__ + "img/cell-phone.995e59f8.png";